import {Permission} from './permission.enum';
import {TranslateService} from '@ngx-translate/core';

export abstract class Base {

  public permissions: Permission[];

  constructor(protected id: number) {}

  public getId() : number {
    return this.id;
  }

  public hasId() {
    return this.id !== undefined && this.id !== null;
  }

  public referenceValue() {
    return this.getId();
  }

  public toTableRow(translate?: TranslateService) {
    return null;
  }

  public abstract getLabel();

  public setPermissions(permissions: string[]) {
    this.permissions = [];
    if (permissions) {
      permissions.forEach(permission => {
        this.permissions.push(Permission[permission]);
      });
    }
  }

  public hasPermission(permission: Permission) {
    return this.permissions?.includes(permission);
  }

}
